import { useTranslation } from 'react-i18next';
import React, { useState, useEffect } from 'react';
import { YhPrint } from "@/erp_subpackage/components/SCMYhPrint";
import { formatNum } from "@/erp_subpackage/utils/util"
import useGlobalModel, { defaultMdCmParam } from "@/erp_subpackage/model/globalModel";
import { Radio } from 'antd';
import { usePurchaseDrDetailsModel } from './purchaseDrDetailsModel';
import { purchaseDrService } from '../../purchaseDrService';
import { getCurrentCurrencySymbol } from '@/utils/currencyUtils';

export function Print() {
	const { t } = useTranslation();
	const { print, setPrint, editFormVal } = usePurchaseDrDetailsModel();
	const [formVal, setFormVal] = useState();
	const [goodsList, setGoodsList] = useState([]);
	const { user } = useGlobalModel();
	useEffect(() => {
		print && getPDrDetailOne()
	}, [print])

	//获取一条数据
	const getPDrDetailOne = async () => {
		let { retData } = await purchaseDrService.one(editFormVal.id);
		let { details, ...formVal } = retData;
		if (retData) {
			setGoodsList(details.sort((a, b) => a.materialCode?.localeCompare(b.materialCode, 'zh-Hans-CN', { sensitivity: 'accent' }))
				.sort((a, b) => a.inShelfCode?.localeCompare(b.inShelfCode, 'zh-Hans-CN', { sensitivity: 'accent' })).map((item, index) => {
					return {
						...item,
						No: index + 1,
					}
				}))
			setFormVal(retData)
		}
	};
	const handlePrintNum = async () => {
		await purchaseDrService.print(editFormVal.id);
	}
	const columns = [
		{
			title: t(`purchase.details.Print.序号`),
			dataIndex: 'No',
		},
		{
			title: t(`purchase.details.Print.商品编号`),
			dataIndex: 'materialCode',
		},
		{
			title: t(`purchase.details.Print.商品名称`),
			dataIndex: 'materialName',
		},
		{
			title: t(`purchase.details.Print.数量`),
			dataIndex: 'num',
		},
		{
			title: t(`purchase.details.Print.商品类型`),
			dataIndex: 'typeName',
		},
		{
			title: t(`purchase.details.Print.单位`),
			dataIndex: 'unitName',
		},
		{
			title: t(`purchase.details.Print.单价`),
			dataIndex: 'price',
		},
		{
			title: t(`purchase.details.Print.金额`),
			dataIndex: 'amount',
			render: (text) => `${getCurrentCurrencySymbol()}${formatNum(text)}`
		},
		{
			title: t(`purchase.details.Print.货位`),
			dataIndex: 'inShelfCode',
		},
	]

	//头部与底部展示
	const printShow = {
		header: [
			{
				fieldLabel: t(`purchase.details.Print.调入单号`),
				fieldValue: formVal?.transferInCode,

			},
			{
				fieldLabel: t(`purchase.details.Print.调出门店`),
				fieldValue: formVal?.outShopName,

			},
			{
				fieldLabel: t(`purchase.details.Print.调入门店`),
				fieldValue: formVal?.shopName,

			},
			{
				fieldLabel: t(`purchase.details.Print.调出实体`),
				fieldValue: formVal?.outBentityName,

			},
			{
				fieldLabel: t(`purchase.details.Print.调出日期`),
				fieldValue: formVal?.transferOutTime ?? "",//当前时间

			},
			{
				fieldLabel: t(`purchase.details.Print.调入日期`),
				fieldValue: formVal?.createTime,

			},
		],
		footer: [
			{
				fieldLabel: t(`purchase.details.Print.制表人`),
				fieldValue: user.userName,
				className: "w20"
			},
			{
				fieldLabel: t(`purchase.details.Print.业务`),
				fieldValue: formVal?.createUser,
				className: "w20"
			},
			{
				fieldLabel: t(`purchase.details.Print.财务`),
				fieldValue: formVal?.createUser,
				className: "w20"
			},
			{
				fieldLabel: t(`purchase.details.Print.库房`),
				fieldValue: formVal?.createUser,
				className: "w20"
			},
			{
				fieldLabel: t(`purchase.details.Print.结算员`),
				fieldValue: formVal?.createUser,
				className: "w20"
			},
			{
				fieldLabel: t(`purchase.details.Print.备注`),
				fieldValue: formVal?.inNote ? formVal?.inNote : formVal?.note ? formVal?.note : "",
				className: "note"
			},
		],
		totalAmount: [
			{
				fieldLabel: t(`purchase.details.Print.应付金额`),
				fieldValue: formVal?.totalAmount,
			},
		]
	}

	const [paperSize, setPaperSize] = useState(34);  //打印的商品条数
	const modalTitle = <>
		<span style={{ marginRight: "15px" }}> {t(`purchase.details.Print.打印详情`)}</span>
		<Radio.Group onChange={(e) => setPaperSize(e.target.value)} value={paperSize}>
			<Radio value={39}>A4</Radio>
			<Radio value={34}>10x11</Radio>
		</Radio.Group>
	</>

	return (
		<YhPrint
			modalTitle={modalTitle}
			title={formVal?.bentityName ?? t(`purchase.details.Print.北京德兴志达商贸有限公司`)}
			type={t(`purchase.details.Print.调入单`)}
			visible={print}
			onClose={() => setPrint(false)}
			columns={columns}
			dataSource={goodsList}
			printShow={printShow}
			paperSize={paperSize}
			writePrintNum={handlePrintNum}
		/>
	);
}

export default Print;
